import utils from "@/stuff/Utils";
import { mapData } from "@/stuff/DataMapping";

export interface INotification {
    id: number;
    text: string;
    expires: Date;
    created: Date;
    createdByUserID: number;
    deleted: Date;
    deletedByUserID: number;
}

export class Notification implements INotification {

    constructor(data?: INotification) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: INotification) {
        mapData(data, { root: () => this });
    }

    id: number = 0;
    text: string = "";
    expires: Date = new Date(utils.emptyDateValue);
    created: Date = new Date(utils.emptyDateValue);
    createdByUserID: number = 0;
    deleted: Date = new Date(utils.emptyDateValue);
    deletedByUserID: number = 0;

    get description() {
        return utils.whenText(this.created); // "Notification id=" + this.id.toString();
    }

    get isNew() {
        return utils.isEmptyId(this.id);
    }
}
